'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadCmsData = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.doLoadCmsData = doLoadCmsData;
exports.watchCmsModalLoaderSagas = watchCmsModalLoaderSagas;

var _universalLogger = require('universal-logger');

var logger = _interopRequireWildcard(_universalLogger);

var _effects = require('redux-saga/effects');

var _sagaTools = require('@classpass/saga-tools');

var _bound = require('redux/saga/entities/bound');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doLoadCmsData),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(watchCmsModalLoaderSagas);

var loadCmsData = exports.loadCmsData = function loadCmsData() {
  return { type: 'CmsModalLoader/LOAD_CMS_DATA' };
};

function doLoadCmsData(client) {
  return _regenerator2.default.wrap(function doLoadCmsData$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.cmsWebContent, [client, 'modals']);

        case 3:
          _context.next = 9;
          break;

        case 5:
          _context.prev = 5;
          _context.t0 = _context['catch'](0);
          _context.next = 9;
          return (0, _effects.call)(logger.error, 'Could not load modal data from CMS', _context.t0);

        case 9:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 5]]);
}

function watchCmsModalLoaderSagas(client) {
  return _regenerator2.default.wrap(function watchCmsModalLoaderSagas$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, loadCmsData().type, doLoadCmsData, client);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}